import React from "react";
import "./homeProductSkeleton.css";

export default function HomeProductSkeletonRow({ title = "Loading..." }) {
  return (
    <div className="home_blow_out_sales">
      <div className="home_blow_out_sale_head_row">
        <h1>{title}</h1>
        <p>View More</p>
      </div>

      <div className="home_blow_out_sales_product_row">
        {Array(5)
          .fill(0)
          .map((_, i) => (
            <div key={i} className="home_skeleton_card">
              <div className="home_skel_img" />
              <div className="home_skel_text home_skel_text-lg" />
              <div className="home_skel_text home_skel_text-sm" />
              <div className="home_skel_btn" />
            </div>
          ))}
      </div>
    </div>
  );
}
